'use client'
import { cn } from '@repo/ui/lib'
import { useEffect, useRef, useState } from 'react'

interface IDashboardProfileHeaderLayoutProps {
  header?: React.ReactNode
  subBgHeader?: React.ReactNode
}

export const DashboardProfileHeaderLayout = (
  props: IDashboardProfileHeaderLayoutProps,
) => {
  const { header, subBgHeader } = props

  const [showColorInHeader, setShowColorInHeader] = useState(false)
  const subHeaderRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!subBgHeader || !subHeaderRef.current) return
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setShowColorInHeader(false)
          } else {
            setShowColorInHeader(true)
          }
        })
      },
      {
        threshold: 0,
        rootMargin: '-64px 0px 0px 0px',
      },
    )

    observer.observe(subHeaderRef.current)

    return () => {
      observer.disconnect()
    }
  }, [subBgHeader, subHeaderRef])

  return (
    <>
      {header && (
        <header
          className={cn(
            'sticky top-0 w-full z-10 dark',
            showColorInHeader ? 'bg-neutral-surface-light' : '',
          )}
        >
          {header}
        </header>
      )}
      {subBgHeader && <div ref={subHeaderRef}>{subBgHeader}</div>}
    </>
  )
}
